export enum CurrentDayAvailabilityExperimentVariants {
	Control = 'control',
	Off = 'off',
}
